'use client'

let sharedSelectionQueue: Promise<void> | null = null

export const SELECTED_TEAM_SESSION_LOCK = 'skop-selected-team-selection'

const runWithBrowserSelectionLock = async <T>(
  operation: () => Promise<T>,
): Promise<T> => {
  if (typeof navigator === 'undefined' || !navigator.locks?.request) {
    return operation()
  }

  return navigator.locks.request(
    SELECTED_TEAM_SESSION_LOCK,
    { mode: 'exclusive' },
    operation,
  )
}

export const runWithSelectedTeamSessionLock = async <T>(
  operation: () => Promise<T>,
): Promise<T> => {
  const previousOperation = sharedSelectionQueue
  let releaseOperation: (() => void) | undefined
  const queuedOperation = new Promise<void>((resolve) => {
    releaseOperation = resolve
  })
  sharedSelectionQueue = queuedOperation

  if (previousOperation) await previousOperation

  try {
    return await runWithBrowserSelectionLock(operation)
  } finally {
    releaseOperation?.()
    if (sharedSelectionQueue === queuedOperation) sharedSelectionQueue = null
  }
}
